/**
 * DocEditor owns Ctrl+Z (block-tree + doc.variables history), so
 * contenteditable's native undo is always preventDefault'd. Paste/cut must
 * force a NEW undo step before they sync through the normal input →
 * onChange → commit path — otherwise a coalesced typing step swallows them
 * (or they never land in history at all if the input event is skipped).
 *
 * Call from doc blocks AND from the in-doc Variables table fields.
 */

let separate = null;

export const registerUndoSeparator = (fn) => {
  separate = typeof fn === 'function' ? fn : null;
  return () => {
    if (separate === fn) separate = null;
  };
};

/** Call before a paste/cut commits so the next content update is its own undo step. */
export const separateNextUndoStep = () => {
  separate?.();
};
